import script from "./Soundcloud.vue?vue&type=script&setup=true&lang=js"
export * from "./Soundcloud.vue?vue&type=script&setup=true&lang=js"

import "./Soundcloud.vue?vue&type=style&index=0&id=6e3cccf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e3cccf0"]])

export default __exports__